<template>
    <div class="tab-pane fade shadow rounded p-4 active show" id="account" role="tabpanel" aria-labelledby="account-details">
        <p
            v-if="responce"
            class="mb-3"
            :class="responce.success ? 'text-success' : 'text-danger'"
        >
            {{responce.success ?? responce.error}}
        </p>

        <form
            method="POST"
            enctype="multipart/form-data"
            @submit.prevent="sendData"
        >
            <div class="mb-3 text-md-start text-center d-sm-flex">
                <img
                    v-if="tempAvatarSrc || user.img"
                    :src="tempAvatarSrc ? tempAvatarSrc : user.img"
                    class="preview avatar float-md-left avatar-medium rounded-circle shadow me-md-4"
                    style="object-fit: cover"
                />

                <input
                    type="hidden"
                    name="avatar_id"
                    :value="user.avatar_id"
                />

                <input
                    type="file"
                    id="avatar"
                    name="avatar[]"
                    class="d-none"
                    ref="fileInput"
                    accept="image/*"
                    @change="onFileChange"
                />

                <div class="mt-md-4 mt-3 mt-sm-0">
                    <label for="avatar">
                        <span class="btn btn-primary mt-2">{{ pll["Change Picture"] }}</span>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <profile-input
                        :label="pll[`Name or alias`] + `*`"
                        :placeholder="pll[`Name or alias`] + ' :'"
                        :required="true"
                        v-model="user.alias"
                        :modelError="vUser.alias.$error"
                        :errors="vUser.alias.$errors.map(e => e.$message)"
                        modelType="text"
                    />
                </div><!--end col-->

                <div class="col-md-6">
                    <profile-input
                        :label="pll[`Your Email`] + `*`"
                        :placeholder="pll[`Your Email`] + ' :'"
                        :required="true"
                        v-model="user.user_email"
                        :modelError="vUser.user_email.$error"
                        :errors="vUser.user_email.$errors.map(e => e.$message)"
                        modelType="email"
                    />
                </div><!--end col-->

                <div
                    class="col-md-6"
                    v-if="user.role === 'user'"
                >
                    <profile-input
                        :label="pll[`Company/Organization`]"
                        :placeholder="pll[`Company/Organization`] + ' :'"
                        :required="false"
                        v-model="user.company_name"
                        :modelError="vUser.company_name.$error"
                        modelType="text"
                    />
                </div><!--end col-->

                <div
                    class="col-md-6"
                    v-if="user.role === 'user'"
                >
                    <profile-input
                        :label="pll[`Position/Role`]"
                        :placeholder="pll[`Position/Role`] + ' :'"
                        :required="false"
                        v-model="user.position"
                        :modelError="vUser.position.$error"
                        modelType="text"
                    />
                </div><!--end col-->

                <div
                    class="col-md-6"
                    v-if="user.role === 'contributor'"
                >
                    <profile-input
                        :label="pll[`Experience`]"
                        :placeholder="pll[`Experience`] + ' :'"
                        :required="false"
                        v-model="user.experience"
                        :modelError="vUser.experience.$error"
                        modelType="text"
                    />
                </div><!--end col-->

                <div
                    class="col-md-6"
                    v-if="user.role === 'contributor'"
                >
                    <profile-input
                        :label="pll[`Qualifications`]"
                        :placeholder="pll[`Qualifications`] + ' :'"
                        :required="false"
                        v-model="user.qualifications"
                        :modelError="vUser.qualifications.$error"
                        modelType="text"
                    />
                </div><!--end col-->

                <div
                    class="col-md-6"
                    v-if="user.role === 'contributor'"
                >
                    <profile-input
                        :label="pll[`Current Role / Employer`]"
                        :placeholder="pll[`Current Role / Employer`] + ' :'"
                        :required="false"
                        v-model="user.current_role_employer"
                        :modelError="vUser.current_role_employer.$error"
                        modelType="text"
                    />
                </div><!--end col-->

                <div class="col-md-6">
                    <div class="mb-3">
                        <profile-text-area
                            :label="pll[`Short description`]"
                            :placeholder="pll[`Short description`] + ' :'"
                            :required="false"
                            v-model="user.short_description"
                            :modelError="vUser.short_description.$error"
                        />
                    </div>
                </div><!--end col-->

                <div class="col-md-6">
                    <profile-select
                        :label="pll[`Country`]"
                        v-model="user.country"
                        :data="this.countries"
                    />
                </div><!--end col-->

                <div class="col-lg-12 mt-2 mb-0">
                    <button type="submit" class="btn btn-primary">{{pll['Save Changes']}}</button>
                </div><!--end col-->
            </div><!--end row-->
        </form>

        <h5 class="mt-4">{{pll['Change password']}}:</h5>
        <form
            method="POST"
            @submit.prevent="sendPassword"
        >
            <div class="row mt-3">
                <div class="col-lg-12">
                    <profile-input
                        :label="pll[`Old password`]"
                        :placeholder="pll[`Old password`] + ' :'"
                        :required="true"
                        v-model="passwords.old_password"
                        :modelError="vPasswords.old_password.$error"
                        :errors="vPasswords.old_password.$errors.map(e => e.$message)"
                        modelType="password"
                    />
                </div><!--end col-->

                <div class="col-lg-12">
                    <profile-input
                        :label="pll[`New password`]"
                        :placeholder="pll[`New password`] + ' :'"
                        :required="true"
                        v-model="passwords.new_password"
                        :modelError="vPasswords.new_password.$error"
                        :errors="vPasswords.new_password.$errors.map(e => e.$message)"
                        modelType="password"
                    />
                </div><!--end col-->

                <div class="col-lg-12">
                    <profile-input
                        :label="pll[`Re-type New password`]"
                        :placeholder="pll[`Re-type New password`] + ' :'"
                        :required="true"
                        v-model="passwords.new_password_repeat"
                        :modelError="vPasswords.new_password_repeat.$error"
                        :errors="vPasswords.new_password_repeat.$errors.map(e => e.$message)"
                        modelType="password"
                    />
                </div><!--end col-->

                <div class="col-lg-12 mt-2 mb-0">
                    <button type="submit" class="btn btn-primary">{{pll['Save Password']}}</button>
                </div><!--end col-->
            </div><!--end row-->

            <p
                v-if="responcePassword"
                class="mt-3"
                :class="responcePassword.success ? 'text-success' : 'text-danger'"
            >
                {{responcePassword.success ?? responcePassword.error}}
            </p>
        </form>
    </div>
</template>
<script>
import responses from "./partials/Responses.vue";
import profileInput from "./partials/Input.vue";
import profileTextarea from "./partials/Textarea.vue";
import profileSelect from "./partials/Select.vue";
import selectSlug from "./partials/SelectSlug.vue";
import checkboxMulti from "./partials/CheckboxMulti.vue";
import checkbox from "./partials/Checkbox.vue";
import ProfileLangAlternative from "./partials/ProfileLangAlternative.vue";
import axios from "axios";
import qs from "qs";
import {useVuelidate} from "@vuelidate/core";
import { reactive } from 'vue'
import {
    email,
    required,
    helpers,
    minLength,
    maxLength,
} from "@vuelidate/validators";

export default {
    components: {
        "profile-input": profileInput,
        "profile-text-area": profileTextarea,
        "profile-select": profileSelect,
        "profile-select-slug": selectSlug,
        "checkbox-multi": checkboxMulti,
        checkbox,
        responses,
        "profile-lang": ProfileLangAlternative,
    },

    setup(props) {
        const user = reactive({
            img: props.user_data.img,
            avatar_id: props.user_data.avatar_id,
            alias: props.user_data.alias,
            short_description: props.user_data.short_description,
            user_email: props.user_data.user_email,
            role: props.user_data.role,
            company_name: props.user_data.company_name,
            position: props.user_data.position,
            experience: props.user_data.experience,
            qualifications: props.user_data.qualifications,
            current_role_employer: props.user_data.current_role_employer,
            country: props.user_data.country['value'],
        });

        const passwords = reactive({
            old_password: '',
            new_password: '',
            new_password_repeat: '',
        });

        const rulesUser = {
            alias: { required },
            user_email: { required, email },
            company_name: {},
            position: {},
            short_description: {},
            experience: {},
            qualifications: {},
            current_role_employer: {},
            country: { required },
        }

        const strongPassword = helpers.withMessage(
            'The password must contain uppercase and lowercase letters, and a number.',
            (value) => {
                if (!value) return false
                const hasUppercase = /[A-Z]/.test(value)
                const hasLowercase = /[a-z]/.test(value)
                const hasNumber    = /[0-9]/.test(value)
                const minLengthOk  = value.length >= 8
                return hasUppercase && hasLowercase && hasNumber && minLengthOk
            }
        );

        const rulesPasswords = {
            old_password: { required },
            new_password: {
                required,
                strongPassword,
                minLength: helpers.withMessage(
                    'The password must be at least 8 characters',
                    minLength(8)
                ),
                maxLength: helpers.withMessage(
                    'The password must be no more than 24 characters',
                    maxLength(24)
                ),
            },
            new_password_repeat: {
                required,
                sameAsPassword: helpers.withMessage(
                    'The passwords don\'t match',
                    (val) => val === passwords.new_password
                ),
            }
        }

        const vUser = useVuelidate(rulesUser, user, { $lazy: true, $autoDirty: true });
        const vPasswords = useVuelidate(rulesPasswords, passwords, { $lazy: true, $autoDirty: true });

        return { user, vUser, passwords, vPasswords };
    },

    data() {
        return {
            countries: this.user_data.countries,
            nonce: api_settings.nonce,
            responce: false,
            responcePassword: false,
            avatarFile: null,
            tempAvatarSrc: null,
            isLoading: false,
        };
    },
    props: {
        user_data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        uploadAvatar() {
            this.isLoading = true;
            const formData = new FormData();
            formData.append("avatar[]", this.avatarFile);
            formData.append("action", "update_user_avatar");

            axios
                .post(api_settings.ajax_url, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    console.log(response);

                    this.responce = response.data;
                    this.isLoading = false;
                    this.scrollToTop();

                    setTimeout(() => {
                        this.responce = false;
                    }, 5000);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async sendPassword() {
            if (!(await this.vPasswords.$validate())) {
                const firstInvalidField = Object.keys(this.passwords).find(
                    key => this.vPasswords[key].$error
                )
                if (firstInvalidField && this.$refs[firstInvalidField]) {
                    this.$refs[firstInvalidField].scrollIntoView({ behavior: 'smooth', block: 'center' })
                }
                return
            }

            this.isLoading = true;

            const formData = new FormData();
            formData.append("user", qs.stringify(this.passwords));
            formData.append("nonce", this.nonce);
            formData.append("action", "update_user_password");

            axios
                .post(api_settings.ajax_url, formData)
                .then((response) => {
                    console.log(response.data);

                    this.responcePassword = response.data;

                    setTimeout(() => {
                        this.responcePassword = false;
                    }, 5000);

                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async sendData() {
            if (!(await this.vUser.$validate())) {
                const firstInvalidField = Object.keys(this.user).find(
                    key => this.vUser[key].$error
                )
                if (firstInvalidField && this.$refs[firstInvalidField]) {
                    this.$refs[firstInvalidField].scrollIntoView({ behavior: 'smooth', block: 'center' })
                }
                return
            }

            this.isLoading = true;

            const formData = new FormData();
            formData.append("user", qs.stringify(this.user));
            formData.append("nonce", this.nonce);
            formData.append("action", "update_user_profile");

            axios
                .post(api_settings.ajax_url, formData)
                .then((response) => {
                    console.log(response.data);

                    this.responce = response.data;

                    const headerName = document.querySelector("#header_display_name");
                    headerName.innerHTML = this.user.alias;

                    setTimeout(() => {
                        this.responce = false;
                    }, 5000);

                    this.scrollToTop();
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onFileChange(e) {
            this.avatarFile = e.target.files[0];
            this.uploadAvatar();

            let reader = new FileReader();
            reader.readAsDataURL(this.avatarFile);
            reader.onload = () => {
                this.tempAvatarSrc = reader.result;
                const profileAvatarBig = document.querySelector("#profile-avatar-big");
                profileAvatarBig.src = reader.result;
                profileAvatarBig.srcset = reader.result;
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        },
    },
    mounted() {
        feather.replace();
    },
};
</script>